<template>
  <div class="columns is-multiline">
    <div class="column is-2-fullhd is-3-tablet" v-if="afficherLogo">
      <figure class="media-left">
        <app-logo
         :canConserveAncienne="canConserveAnciennePj"/>
      </figure>
    </div>
    <div class="column" :class="afficherLogo
    ? 'is-10-fullhd is-9-tablet' : 'is-12'">
      <div class="card">
        <header class="header-card">
          <p>
            {{ $t('catalogue.tab.products') }}
          </p>
        </header>
        <div class="card-content">
          <div class="columns">
            <div class="column is-6-fullhd is-6-tablet">
              <div class="columns is-12 is-multiline">
                <div class="column"
                    :class="(!isProduitDiversOrLocationOrImpressionAffiche
                    && (agencesSelectionnees.length > 1
                    ||  societesInformations.length > 1)
                    || isProduitDiversOrLocationOrImpressionAffiche
                    && societesInformations.length > 1)
                    ? 'is-6' : 'is-12'">
                  <b-field :label="$t('catalogue.newProduct.productReference')"
                           :class="{'obligatoire' : !face && !materiel}">
                    <b-input
                      :disabled="isSynchro"
                      :class="{'is-danger': referenceHasError}"
                      v-model="produit.reference"></b-input>
                  </b-field>
                </div>
                <div class="column is-6"
                  v-if="!isProduitDiversOrLocationOrImpressionAffiche
                    && agencesSelectionnees.length > 1">
                  <selection-agence v-model="produit.agenceId" obligatoire
                                    :disabled="isSynchro"
                                    set-first-agence-find>
                  </selection-agence>
                </div>
                <div class="column is-6" v-if="societesInformations.length > 1">
                   <b-field  :label="$t('catalogue.newProduct.societe')">
                     <b-select v-model="societeForGetAll" disabled
                        expanded>
                      <option v-for="societe in societeOfUser"
                              :key="societe.societeId"
                              :value="societe.societeId">
                        {{societe.libelleSociete}}
                      </option>
                    </b-select>
                   </b-field>
                </div>
                <div class="column is-12" v-if="showSecteur">
                  <secteur-lien-tag-input
                    :label="$t('catalogue.newProduct.secteur')"
                    v-model="produit.secteurs"
                    :critere="secteurTypeFilter"
                  />
                </div>
              </div>
              <div v-if="produitDetails"
                   class="columns is-multiline">
                <div class="column is-marginless"
                  :class="isProduitDiversOrLocationOrImpressionAffiche ? 'is-3' : 'is-4'">
                  <label class="label">{{ $t('catalogue.newProduct.quantite') }}</label>
                  <b-field >
                    <input-currency ref="quantite"
                                    isNumber="true"
                                    class="no-border-radius-right"
                                    v-model="produitDetails.quantite">
                    </input-currency>
                    <p class="control" >
                      <b-dropdown position="is-bottom-left">
                        <button class="button select pdl-5px is-55px-width" slot="trigger">
                          <span class='is-pulled-left'>{{ $t(unite) }}</span>
                        </button>
                        <b-dropdown-item @click="changerUnite()">
                          &nbsp;
                        </b-dropdown-item>
                        <b-dropdown-item v-for="unite in listeUniteQuantite"
                                         :key="unite.code"
                                         @click="changerUnite(unite)">
                          {{ $t(unite.initiale) }} ({{ $t(unite.libelle) }})
                        </b-dropdown-item>
                      </b-dropdown>
                    </p>
                  </b-field>
                </div>
                <div class="column is-marginless"
                  :class="isProduitDiversOrLocationOrImpressionAffiche ? 'is-3' : 'is-4'">
                  <b-field :label="$t('catalogue.newProduct.prixUnitaire')">
                    <input-currency v-model="produitDetails.prixUnitaire"
                                    isNumber="true">
                    </input-currency>
                  </b-field>
                </div>
                <div class="column"
                  :class="isProduitDiversOrLocationOrImpressionAffiche
                    ? 'is-2 is-marginless' : 'is-4'">
                  <b-field :label="$t('catalogue.newProduct.tva')"
                           class="obligatoire">
                      <b-select v-model="produit.tauxTva">
                        <option v-for="tva in regimeTva"
                                :key="tva.tauxTva"
                                :value="tva.tauxTva">
                          {{ tva.tauxTva | formatPercent }}
                        </option>
                      </b-select>
                  </b-field>
                </div>
                <div class="column is-4"  v-if="isProduitDiversOrLocationOrImpressionAffiche">
                  <b-field :label="$t('catalogue.newProduct.categorieOperation')">
                      <b-select v-model="produit.categorieOperation">
                        <option :value="null"></option>
                        <option v-for="categorie in categorieOperations"
                                :key="categorie.code"
                                :value="categorie.code">
                          {{ $t(categorie.libelle) }}
                        </option>
                      </b-select>
                  </b-field>
                </div>
                <div class="column is-4" v-if="produit.produitDivers">
                  <qd-checkbox v-model="produit.produitDivers.tlpe"
                              class="mgt-10px">
                    <span class="label">{{ $t('catalogue.newProduct.tlpe') }}</span>
                  </qd-checkbox>
                </div>
                <div class="column is-4" v-if="produit.produitDivers">
                  <qd-checkbox v-model="produit.produitDivers.honoraire"
                              class="mgt-10px">
                    <span class="label">{{ $t('catalogue.newProduct.honoraire') }}</span>
                  </qd-checkbox>
                </div>
                <div class="column is-4" v-if="produit.produitDivers && moduleStockTiersActive">
                  <qd-checkbox v-model="produit.stockable"
                    class="mgt-10px">
                    <span class="label">{{ $t('catalogue.newProduct.stockable') }}</span>
                  </qd-checkbox>
                </div>
                <div class="column is-4" v-if="produit.produitDivers && modulePresseActive">
                  <qd-checkbox v-model="produit.produitDivers.commissionnable"
                              class="mgt-10px">
                    <span class="label">{{ $t('catalogue.newProduct.commissionnable') }}</span>
                  </qd-checkbox>
                </div>
                <div class="column is-4"
                     v-if="produit.produitLocation && produit.numerique">
                  <b-field :label="$t('catalogue.newProduct.saturation')" class="obligatoire">
                    <div class="columns is-marginless is-vcentered">
                      <span class="column is-narrow has-text-link
                        is-size-6 is-paddingless mgr-5px">
                        {{$t('catalogue.newProduct.saturationLabel')}}
                      </span>
                      <b-select
                        class="column is-paddingless pdl-5px"
                        v-model="produit.produitLocation.saturation">
                        <option v-for="saturation in 12" :value="saturation" :key="saturation">
                          {{ $t(saturation) }}
                        </option>
                      </b-select>
                    </div>
                  </b-field>
                </div>
              </div>
              <div class="columns">
                <b-field
                  v-if="showLogisticable"
                  class="column is-narrow">
                  <qd-checkbox v-model="produit.logisticable" class="mgt-10px">
                    {{ $t('catalogue.newProduct.logisticable') }}
                  </qd-checkbox>
                </b-field>
                <b-field
                  v-if="ligneCommandeARenouvelerSpe && !produit.produitImpressionAffiche"
                  class="column is-narrow">
                  <qd-checkbox v-model="produit.renouvelable" class="mgt-10px">
                    {{ $t('catalogue.newProduct.renouvelable') }}
                  </qd-checkbox>
                </b-field>
              </div>
            </div>
            <div class="column">
              <b-field :label="$t('catalogue.newProduct.productLabel')"
                       :class="{'obligatoire' : !disabledLibelle}">
                <textarea class="textarea"
                          :disabled="disabledLibelle"
                          :class="{'is-danger': labelHasError}"
                          rows="4"
                          v-model="produit.libelle"></textarea>
              </b-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <produit-dispositif v-if="produit.produitDispositif"
      :produitDispositif="produit.produitDispositif"/>
    <div class="column is-12"
      v-if="isProduitDiversOrLocationOrImpressionAffiche || produit.produitDispositif">
      <div class="card">
        <header class="header-card">
          <p>
            {{ $t('catalogue.newProduct.comptabilite.title') }}
          </p>
        </header>
        <div class="card-content columns">
          <schema-comptable :objetAvecSchemaComptable="produit"
                            class="column is-8">
          </schema-comptable>
          <select-compte-analytique class="column is-4"
                                    :produit="produit">
          </select-compte-analytique>
        </div>
      </div>
    </div>
    <produit-commentaire-vente-card
      v-if="!isProduitSensAchat"
      :produit="produit"
      class="column is-12"/>
    <div v-if="isProduitDiversOrLocationOrImpressionAffiche || produit.produitDispositif"
      class="column" :class="hasHolding ? 'is-6' : 'is-12'">
      <edition-dcf :produit="produit">
      </edition-dcf>
    </div>
    <compte-analytique
      v-else :produit="produit"
    >
    </compte-analytique>
    <div v-if="(isProduitDiversOrLocationOrImpressionAffiche && hasHolding)
      || modulePresseActive
      || produit.produitDispositif
      || (produit.produitDivers && moduleStockTiersActive)"
      class="column is-6">
      <produit-oppose-lie :produit="produit"></produit-oppose-lie>
    </div>
    <div class="column is-6" v-if="modulePresseActive">
      <div class="card">
        <header class="header-card">
          <p>{{ $t('catalogue.newProduct.infoMarche') }}</p>
        </header>
        <div class="card-content">
          <marche v-show="moduleMarcheActive"
            :produit="produit"
            :disabled="!!produit.regroupementProduitId"
            class="mgb-10px">
          </marche>
          <regle-facturation
            :produit="produit"
            :disabled="!!produit.regroupementProduitId">
          </regle-facturation>
        </div>
      </div>
    </div>
    <div class="column" v-if="afficherPj">
      <div class="card" id="attachments">
          <header class="header-card">
            <p>
              {{ $t('piecesJointes.attachments')}}
            </p>
          </header>
          <div class="card-content">
            <app-pieces-jointes :checkPermissions=checkPermissions(permsCatalogue.maj)
                                readOnly
                                deletable
                                />
          </div>
        </div>
      </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import PiecesJointes from '@/components/general/piecesJointes';
import Logo from '@/components/general/Logo';
import inputCurrency from '@/components/general/inputCurrency';
import * as devisConf from '@/configuration/devisConf';
import { CATALOGUE } from '@/configuration/permissionsBodacConf';
import schemaComptable from '@/components/general/schemaComptable';
import * as produitConf from '@/configuration/catalogue/produitConf';
import { PARAMETRES_KEYS, PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import selectCompteAnalytique from '@/components/catalogue/produitGeneral/compteAnalytique/selectCompteAnalytique';
import compteAnalytique from '@/components/catalogue/produitGeneral/compteAnalytique/m_compteAnalytiqueCard';
import produitCommentaireVenteCard from '@/components/catalogue/produitGeneral/produitCommentaireVenteCard';
import SelectionAgence from '@/components/general/selectionAgence';
import EditionDcf from '@/components/catalogue/produitGeneral/editionDcf/m_editionDcf';
import produitOpposeLie from '@/components/general/produitOpposeLie';
import regleFacturation from '@/components/catalogue/produitGeneralPresse/edition/regleFacturation';
import marche from '@/components/catalogue/produitGeneralPresse/edition/marche';
import produitDispositif from '@/components/catalogue/detail/produitDispositif/produitDispositif';
import { siteHasHolding } from '@/services/general/holding';
import secteurLienTagInput from '@/components/commun/secteur/secteurLienTagInput';
import { COMMERCIAL } from '@/configuration/parametrage/secteurConf';
import MixinParametreInterne from '@/mixins/parametreInterne';

const permissions = createNamespacedHelpers('permissions');
const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');
const User = createNamespacedHelpers('user');

export default {
  mixins: [MixinParametreInterne],
  props: {
    produit: {
      type: Object,
      required: true,
    },
    face: {
      type: Object,
      required: false,
    },
    materiel: {
      type: Object,
      required: false,
    },
    produitDetails: {
      type: Object,
      required: false,
    },
    afficherLogo: {
      type: Boolean,
      required: false,
      default: true,
    },
    afficherPj: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  components: {
    SelectionAgence,
    inputCurrency,
    secteurLienTagInput,
    appPiecesJointes: PiecesJointes,
    appLogo: Logo,
    schemaComptable,
    selectCompteAnalytique,
    compteAnalytique,
    produitOpposeLie,
    EditionDcf,
    regleFacturation,
    marche,
    produitDispositif,
    produitCommentaireVenteCard,
  },
  data: () => ({
    listeUniteQuantite: devisConf.LISTE_UNITES,
    permsCatalogue: CATALOGUE,
    categorieRegroupement: produitConf.CATEGORIE_REGROUPEMENT,
    societeForGetAll: null,
    categorieOperations: produitConf.CATEGORIE_OPERATION,
  }),
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...Societe.mapGetters({
      societeActive: 'societeActive',
      agencesSelectionnees: 'agenceActive',
      societesInformations: 'societesInformations',
      societeOfUser: 'societeOfUser',
    }),
    ...User.mapGetters({
      utilisateur: 'user',
    }),
    modulePresseActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
    moduleSecteurActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleSecteur.key);
    },
    canConserveAnciennePj() {
      return this.produit?.supportCommercial?.categorieVente === produitConf.CATEGORIE_UNITAIRE;
    },
    showSecteur() {
      return this.moduleSecteurActive
        && [
          produitConf.CATEGORIE_REGROUPEMENT,
          produitConf.CATEGORIE_UNITAIRE,
        ].includes(this.produit.supportCommercial.categorieVente);
    },
    showLogisticable() {
      return [
        produitConf.CATEGORIE_REGROUPEMENT,
        produitConf.CATEGORIE_REGROUPEMENT_LC,
      ].includes(this.produit.supportCommercial.categorieVente);
    },
    isSynchro() {
      return this.face != null || this.materiel != null;
    },
    disabledLibelle() {
      return this.face
        || this.materiel
        || (this.produit.supportCommercial.categorieVente === produitConf.CATEGORIE_ECRAN_NUMERIQUE
          && this.societeActive.masqueLibelleProduitEcranNumeriqueNonPatrimonial !== ''
            && this.societeActive.masqueLibelleProduitEcranNumeriqueNonPatrimonial !== null)
        || (this.produit.supportCommercial.categorieVente === produitConf.CATEGORIE_UNITAIRE
          && this.societeActive.masqueLibelleProduitUnitaireNonPatrimonial !== ''
            && this.societeActive.masqueLibelleProduitUnitaireNonPatrimonial !== null);
    },
    referenceHasError() {
      return this.$parent.error && !this.produit.reference ? 'is-danger' : '';
    },
    labelHasError() {
      return this.$parent.error && !this.produit.libelle ? 'is-danger' : '';
    },
    regimeTva() {
      return this.parametre(PARAMETRES_KEYS.regimeTva).filter((tva) => {
        return tva.actif || this.produit.tauxTva === tva.tauxTva;
      });
    },
    unite() {
      const uniteVente = this.listeUniteQuantite.find((unite) => {
        return unite.code === this.produitDetails.uniteVente;
      });
      if (uniteVente) {
        return uniteVente.initiale;
      }
      return '';
    },
    isProduitDiversOrLocationOrImpressionAffiche() {
      return this.produit.produitDivers
        || this.produit.produitLocation
        || this.produit.produitImpressionAffiche;
    },
    hasHolding() {
      return siteHasHolding();
    },
    moduleStockTiersActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleStockTiers.key);
    },
    moduleMarcheActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleMarche.key);
    },
    isProduitSensAchat() {
      return this.produit.sens === devisConf.SENS_ACHAT;
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
    changerUnite(unite) {
      if (!unite) {
        this.produitDetails.uniteVente = null;
      } else {
        this.produitDetails.uniteVente = unite.code;
      }
    },
    secteurTypeFilter(secteur) {
      return secteur.type === COMMERCIAL;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key,
        PARAMETRES_INTERNE_KEYS.modulePresse.key,
        PARAMETRES_INTERNE_KEYS.moduleStockTiers.key,
        PARAMETRES_INTERNE_KEYS.moduleSecteur.key,
        PARAMETRES_INTERNE_KEYS.moduleMarche.key]);
      this.societeForGetAll = this.produit.supportCommercial.societeId;
      if (!this.produit.agenceId) {
        if (this.agencesSelectionnees.find((agence) => {
          return agence.agenceId === this.utilisateur.agenceId;
        })) {
          this.produit.agenceId = this.utilisateur.agenceId;
        } else this.produit.agenceId = this.agencesSelectionnees[0].agenceId;
      }
      await this.loadParametres([
        PARAMETRES_KEYS.regimeTva,
      ]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
